import { pruneSelection } from './applySelection';

const toId = (value) => {
  if (value == null || value === '') return '';
  if (typeof value === 'object') return String(value._id || value.id || '');
  return String(value);
};

export function parseDeleteVariantResult(data, fallbackVariantId) {
  const deletedVariantIds = (
    Array.isArray(data?.deletedVariantIds) && data.deletedVariantIds.length
      ? data.deletedVariantIds
      : [fallbackVariantId]
  ).map(toId).filter(Boolean);

  const wipedListingIds = (Array.isArray(data?.wipedListings) ? data.wipedListings : [])
    .map(toId)
    .filter(Boolean);

  return { deletedVariantIds, wipedListingIds };
}

export default function pruneDeletedListingRows(state, {
  listingIds = [],
  variantIds = [],
} = {}) {
  const wipedListings = new Set(listingIds.map(String).filter(Boolean));
  const removedVariants = new Set(variantIds.map(String).filter(Boolean));
  if (!wipedListings.size && !removedVariants.size) return;

  if (Array.isArray(state.search?.items)) {
    const prevLength = state.search.items.length;
    state.search.items = state.search.items.filter((item) => {
      const id = String(item._id);
      const base = item.baseProductId != null ? String(item.baseProductId) : '';
      if (wipedListings.has(id) || wipedListings.has(base)) return false;
      if (removedVariants.has(id)) return false;
      return true;
    });
    const removedCount = prevLength - state.search.items.length;
    if (removedCount > 0) {
      state.search.total = Math.max(0, (state.search.total || 0) - removedCount);
    }
  }

  const selection = state.ui?.selection;
  if (!selection?.keys?.length) return;

  const keysToRemove = selection.keys.filter((key) => {
    const entry = selection.byKey?.[key];
    if (!entry) return false;
    if (entry.type === 'listing' && wipedListings.has(String(entry._id))) return true;
    if (entry.type === 'listingVariant') {
      if (removedVariants.has(String(entry._id))) return true;
      if (wipedListings.has(String(entry.baseProductId))) return true;
    }
    return false;
  });

  state.ui.selection = pruneSelection(selection, keysToRemove);
}
